"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const loanCustomerInfo_1 = __importDefault(require("../../components/customerInfo/loanCustomerInfo"));
const internalLoanCustomerInfo_1 = __importDefault(require("../../components/customerInfo/internalLoanCustomerInfo"));
const internalLoanDetails_1 = __importDefault(require("../../components/loanDetails/internalLoanDetails"));
const typesConstants_1 = require("../../constants/typesConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const communicationBox_1 = __importDefault(require("../../components/communicationBox/communicationBox"));
const loanDetails_1 = __importDefault(require("../../components/loanDetails/loanDetails"));
const historyBox_1 = __importDefault(require("../../components/historyBox/historyBox"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const colors_1 = __importDefault(require("../../styles/colors"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const constants_1 = require("../../constants/constants");
const schedulesConstants_1 = require("./schedulesConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const communicationBoxUtils_1 = require("../../components/communicationBox/communicationBoxUtils");
const utils_1 = require("../../utils/utils");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const actionHistoryTable_1 = __importDefault(require("../../components/historyBox/actionHistoryTable/actionHistoryTable"));
const defaultProps = {
    hasCompletedLastSchedule: false,
    displayActions: true,
};
const ScheduleComponent = ({ pageContent, loan, schedule, loadingStatus, hasCompletedLastSchedule, displayActions, }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    const [customPhoneNumber, setCustomPhoneNumber] = react_1.useState('');
    let content;
    let contacts = [];
    const { errorMessage } = useAppSelector_1.default((state) => ({
        errorMessage: state.schedule.errorMessage,
    }));
    if (loan) {
        contacts = utils_1.isInternalLoan(loan)
            ? communicationBoxUtils_1.getInternalLoanContacts(loan.borrowers[0], customPhoneNumber)
            : communicationBoxUtils_1.getAllContacts(loan.borrowers[0], customPhoneNumber);
    }
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const containerCustomerVoip = isDesktop ? [styles_1.default.flexDirectionRow] : [];
    const callContainerStyle = isDesktop && styles_1.default.flexOne;
    if (loan && schedule && contacts.length) {
        if (utils_1.isInternalLoan(loan)) {
            content = (react_1.default.createElement(react_native_1.View, { style: containerStyle },
                pageContent,
                react_1.default.createElement(react_native_1.View, { style: containerCustomerVoip },
                    react_1.default.createElement(react_native_1.View, { style: callContainerStyle },
                        react_1.default.createElement(internalLoanCustomerInfo_1.default, { loan: loan })),
                    displayActions && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                        react_1.default.createElement(communicationBox_1.default, { contacts: contacts, scheduleId: schedule.id, setCustomPhoneNumber: setCustomPhoneNumber })))),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(internalLoanDetails_1.default, { loanData: loan.loan_data })),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, { zIndex: 10 }] },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.alignCenterStart },
                            react_1.default.createElement(boxTitle_1.default, { title: "History" }))),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(actionHistoryTable_1.default, { historyActions: loan.loan_history })))));
        }
        else {
            content = (react_1.default.createElement(react_native_1.View, { style: containerStyle },
                pageContent,
                react_1.default.createElement(react_native_1.View, { style: containerCustomerVoip },
                    react_1.default.createElement(react_native_1.View, { style: callContainerStyle },
                        react_1.default.createElement(loanCustomerInfo_1.default, { loan: loan, scheduleId: schedule.id, displayActions: displayActions })),
                    displayActions && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                        react_1.default.createElement(communicationBox_1.default, { contacts: contacts, scheduleId: schedule.id, setCustomPhoneNumber: setCustomPhoneNumber })))),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(loanDetails_1.default, { loanData: loan.loan_data, actions: loan.available_actions, displayActions: displayActions })),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(historyBox_1.default, { previousStages: loan.loan_history.previous_stages, currentStage: loan.loan_history.current_stage, nextStages: loan.loan_history.next_stages, actions: loan.loan_history.actions }))));
        }
    }
    else if (loadingStatus === typesConstants_1.FAILED_STATUS) {
        if (errorMessage === constants_1.NO_SCHEDULES_MESSAGE) {
            content = react_1.default.createElement(messageComponent_1.default, { message: errorMessage, color: colors_1.default.GREEN, icon: free_solid_svg_icons_1.faCheckCircle });
        }
        else {
            content = react_1.default.createElement(messageComponent_1.default, { message: errorMessage, color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
        }
    }
    else if (schedule && schedule.status === schedulesConstants_1.SCHEDULE_STATUS_COMPLETED && hasCompletedLastSchedule) {
        content = react_1.default.createElement(messageComponent_1.default, { message: constants_1.NO_SCHEDULES_MESSAGE, color: colors_1.default.GREEN, icon: free_solid_svg_icons_1.faCheckCircle });
    }
    else {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    return react_1.default.createElement(navBar_1.default, null, content);
};
ScheduleComponent.defaultProps = defaultProps;
exports.default = ScheduleComponent;
